import { BROADCAST_CHANNEL_NAME } from '@deephaven/jsapi-utils';
import Log from '@deephaven/log';
import { EMPTY_FUNCTION, isMessage } from '@deephaven/utils';
import { useEffect, useMemo } from 'react';
var log = Log.module('useBroadcastChannel');
export function useBroadcastChannel() {
  var onEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_FUNCTION;
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : BROADCAST_CHANNEL_NAME;
  var channel = useMemo(() => new BroadcastChannel(name), [name]);
  useEffect(() => () => {
    channel.close();
  }, [channel]);
  useEffect(() => {
    function handleEvent(event) {
      var data = event.data;
      if (!isMessage(data)) {
        log.debug('Ignoring non-deephaven message', data);
        return;
      }
      log.debug('event received', data);
      onEvent(event);
    }
    channel.addEventListener('message', handleEvent);
    return () => {
      channel.removeEventListener('message', handleEvent);
    };
  }, [channel, onEvent]);
  return channel;
}
export default useBroadcastChannel;
//# sourceMappingURL=useBroadcastChannel.js.map